<template>
  <div class="color-sku-item">
    <a-space>
       <span style="width: 50px;display: inline-block">
      {{ item.value }}
      </span>
      <span>
        <a-upload
          style="width: 40px;height: 40px"
          name="file"
          :headers="headers"
          :show-upload-list="false"
          :action="uploadUrl"
          :before-upload="beforeAvatarUpload"
          @change="handleChange"
        >
          <div :class="['img-wrap',currentImgPath?'uploaded':'']">
            <img v-if="currentImgPath" :src="currentImgPath" class="overview"/>
            <div style="text-align: center;" v-if="!currentImgPath">
              <a-icon style="text-align: center" :type="loading ? 'loading' : 'camera'"/>
            </div>
          </div>
  </a-upload>
      </span>
    </a-space>
    <span class="operate-button" @click="remove">
      删除
    </span>
  </div>
</template>

<script>
export default {
  name: 'ColorSkuItem',
  props: {
    item: Object,
  },
  data() {
    return {
      imageUrl: this.item.imgPath || '',
      loading: false,
      currentImgPath: this.item.imgPath,
      headers: {
        token: localStorage.getItem('token'),
      },
      uploadUrl: `${process.env.VUE_APP_BASE_URL}/upload`,
    };
  },
  created() {
  },
  methods: {
    remove() {
      this.$emit('onRemove', this.item);
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        this.loading = false;
        this.currentImgPath = info.file.response;
        this.$emit('onColorImgUpload', {
          ...this.item,
          imgPath: this.currentImgPath,
        });
      }
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    handleAvatarSuccess(res) {
      this.currentImgPath = res;
    },
    beforeAvatarUpload(file) {
      return true;
    },
  },
};
</script>

<style scoped>
.color-sku-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  line-height: 50px;
}

.color-sku-item:hover .operate-button {
  display: block;
}

.img-wrap {
  width: 50px;
  height: 50px;
  line-height: 50px;
  background: #e5e7eb;
  cursor: pointer;
}

.img-wrap.uploaded {
  background: unset;
}

.overview {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.operate-button {
  cursor: pointer;
  color: #f5222d;
}
</style>
